import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { MOCK_DATA } from '../utils/mock';

const TestimonialSection = () => {
  return (
    <section id="testimonials" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl font-bold text-slate-900">
            Was unsere Kunden sagen
          </h2>
          <p className="text-xl text-slate-600">
            Über 500 erfolgreiche Unternehmen vertrauen auf 2besales
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {MOCK_DATA.testimonials.map((testimonial, idx) => (
            <Card key={idx} className="border-2 hover:border-blue-300 transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-8 space-y-6">
                <Quote className="w-10 h-10 text-blue-200" />
                
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                <p className="text-slate-700 leading-relaxed italic">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-4 pt-4 border-t border-slate-200">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900">{testimonial.name}</div>
                    <div className="text-sm text-slate-600">{testimonial.position}</div>
                    <div className="text-sm text-slate-500">{testimonial.company}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
